// src/components/RouteFallback.jsx
//
// Tiny placeholder rendered while a React.lazy() route chunk is being
// fetched. Replaces the previous `<Suspense fallback={null}>` that
// caused a white screen on slow networks (mobile in particular).
//
// Design goals:
//   • Ship in the eager bundle — no imports beyond React, no CSS file.
//   • Render *something* immediately so users never look at a pure
//     white viewport longer than ~50ms.
//   • Match the surrounding chrome's minimum height so the page
//     doesn't visibly jump when the real route mounts.
//   • Cheap on low-end mobile: a single CSS keyframe spinner, no
//     framer-motion / lottie, no image requests.
import React from "react";

export default function RouteFallback({ minHeight = "60vh", label = "Loading…" }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        color: "#666",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 12,
        }}
      >
        <span
          aria-hidden="true"
          style={{
            width: 28,
            height: 28,
            borderRadius: "50%",
            border: "3px solid #e5e5e5",
            borderTopColor: "#111",
            animation: "lex-route-fallback-spin 0.9s linear infinite",
          }}
        />
        <span style={{ fontSize: 13, letterSpacing: "0.04em" }}>{label}</span>
      </div>
      <style>
        {`@keyframes lex-route-fallback-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }`}
      </style>
    </div>
  );
}
